import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import {
  clickToCopy,
  isIncluded,
  shareOnline,
} from "../../Datas/Functions/shareFunctions";
import { Link } from "react-router-dom";
import { notify } from "../../Datas/Functions/toast";
import Textinput from "../SiteComponants/FormElements/Textinput";
import { useForm } from "react-hook-form";
import { useSiteData } from "../../Contexts/SiteContext";
import { useAuthContext } from "../../Contexts/AuthContext";
import moment from "moment/moment";
import { ModalInvoice } from "../../Datas/Functions/common";
const ProductDetails = ({ productItem = {} }) => {
  const { setIsLoading, isDark } = useSiteData();
  const { user } = useAuthContext();
  const [selectedItem, setSelecteditem] = useState(null);
  const [trxId, setTrxId] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [selectedPaymentMethod, setSelectedPayementMethod] = useState("BKash");

  const { id, name, category, productInfo, customerInput } = productItem;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  console.log(user);
  // submit form section to handle
  const onSubmit = (data) => {
    if (accountNumber === "") {
      notify("Empty value", "Please Enter Your Account Number", "error");
      return;
    }
    if (trxId === "") {
      notify("Empty value", "Please Enter Your Transaction ID", "error");
      return;
    }
    setIsLoading(true);
    const userInput = Object.entries(data)?.map(([key, val]) => {
      return { key, val };
    });
    let finalOrderData = {
      id: 994,
      order_status: "Proccessing",
      order_payment_method: selectedPaymentMethod,
      order_trxid: trxId,
      order_account: accountNumber,
      created_at: moment().unix(),
      customer_id: user?.id,
      customer_name: user?.name,
      product_id: id,
      product_category: category,
      product_name: name,
      order_name: selectedItem.title,
      order_price: selectedItem.price,
      userInput,
    };

    console.log(finalOrderData);
    setIsLoading(false);
    ModalInvoice(finalOrderData, isDark);
    reset();
  };
  return (
    <div className="w-full ml-3 px-3">
      <h1 className="font-bold my-3 px-2 text-3xl  inline-block border-b-2 border-b-orange-400">
        {name}
      </h1>
      <div className="py-4 my-2" id={name}>
        <h2 className="text-xl font-bold block">Prices : </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 ">
          {productInfo.map((pinf, i) => (
            <Tooltip key={i} title={<span>{pinf.price} &#2547;</span>} arrow>
              <span className="col-span-1 block">
                <button
                  className={`w-full relative ring-2 dark:disabled:bg-gray-500  disabled:bg-gray-300 disabled:hover:cursor-not-allowed disabled:text-gray-800 my-1 mr-2 ring-gray-500 rounded p-2 cursor-pointer  ${
                    isIncluded(pinf.stock, "unav")
                      ? ""
                      : "hover:ring-orange-500"
                  } ${selectedItem?.key === i ? "ring-orange-600 ring-4" : ""}`}
                  key={i}
                  onClick={() => {
                    !isIncluded(pinf.stock, "unav") &&
                      setSelecteditem({ key: i, ...pinf });
                  }}
                  disabled={isIncluded(pinf.stock, "unav")}
                >
                  <h1 className="text-xl ">{pinf.title}</h1>
                  <p className="font-bold text-brand">{pinf.price} &#2547;</p>
                  <p className="text-sm font-semibold">Stock {pinf.stock}</p>
                </button>
              </span>
            </Tooltip>
          ))}
        </div>

        {selectedItem !== null && (
          <div>
            <button
              onClick={() => setSelecteditem(null)}
              className="p-2 border rounded my-3 flex flex-wrap items-baseline border-gray-300"
            >
              Clear Selection
              <i className="fa fa-times text-red-700 ml-1" aria-hidden="true"></i>
            </button>
            <div className="w-full py-5 text-xl text-center bg-orange-500 rounded dark:dark-text font-bold">
              Selected Price : {selectedItem?.price} &#2547;
            </div>
          </div>
        )}
      </div>
      <div className="my-4">
        <table className="w-full md:w-1/2">
          <tbody>
            <tr>
              <td>Category</td>
              <td>:</td>
              <td className="font-bold text-right text-brand ml-">
                {category}
              </td>
            </tr>
            <tr>
              <td>Share the product </td>
              <td>:</td>
              <td className="font-bold text-right text-brand ml-">
                <Link
                  to={
                    "https://www.facebook.com/sharer/sharer.php?u=" +
                    window.location.href
                  }
                >
                  <button className="mx-2 text-2xl text-blue-800 hover:text-brand">
                    <i className="fab fa-facebook" aria-hidden="true"></i>
                  </button>
                </Link>
                <Link
                  to={
                    "https://twitter.com/intent/tweet?url=" +
                    window.location.href
                  }
                >
                  <button className="mx-2  text-2xl text-blue-500 hover:text-brand">
                    <i className="fab fa-twitter" aria-hidden="true"></i>
                  </button>
                </Link>
                <Link
                  to={
                    "https://www.linkedin.com/sharing/share-offsite/?url=" +
                    window.location.href
                  }
                >
                  <button
                    onClick={() =>
                      shareOnline(window.location.href, "linkedin")
                    }
                    className=" mx-2 text-2xl text-blue-900 hover:text-brand"
                  >
                    <i className="fab fa-linkedin" aria-hidden="true"></i>
                  </button>
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {selectedItem !== null && (
        <div>
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div>
              {customerInput.map((inp, i) => (
                <Textinput
                  key={i}
                  title={inp.title}
                  name={inp.title}
                  type={inp.type}
                  placeholder={"Carefully fillup Your Data"}
                  errors={errors}
                  className={`border rounded w-full py-2 px-4 ${
                    errors.name ? "border-red-500" : "border-orange-300"
                  }`}
                  register={register(inp.title, {
                    required: inp.title + " is required",
                  })}
                />
              ))}
              <div>
                <div>
                  <ul className="font-bold">
                    <li>
                      <label>
                        <input
                          type="radio"
                          value="BKash"
                          onChange={(e) =>
                            setSelectedPayementMethod(e.target.value)
                          }
                          checked={selectedPaymentMethod === "BKash"}
                        />
                        <span className="ml-2">BKash Payment</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          type="radio"
                          value="Nagad"
                          onChange={(e) =>
                            setSelectedPayementMethod(e.target.value)
                          }
                          checked={selectedPaymentMethod === "Nagad"}
                        />
                        <span className="ml-2">Nagad Payment</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          name="payment_method"
                          type="radio"
                          value="other"
                          onChange={(e) =>
                            setSelectedPayementMethod("")
                          }
                          checked={selectedPaymentMethod === ""}
                        />
                        <span className="ml-2">Other</span>
                      </label>
                    </li>
                  </ul>
                </div>

                {selectedPaymentMethod !== "" && (
                  <>
                    <div className="p-4 border rounded">
                      <h2 className="text-2xl underline font-semibold text-center text-brand my-2">
                        টাকা পাঠানোর নিয়মাবলী{" "}
                      </h2>
                      <p className="text-lg  font-mono  text-justify">
                        <span className="font-semibold">
                          {selectedPaymentMethod === "BKash"
                            ? "*247#"
                            : selectedPaymentMethod === "Nagad"
                            ? "*167#"
                            : ""}{" "}
                        </span>
                        ডায়াল করে আপনার{" "}
                        <span className="font-semibold">
                          {" "}
                          {selectedPaymentMethod === "BKash"
                            ? "বিকাশ"
                            : selectedPaymentMethod === "Nagad"
                            ? "নগদ"
                            : ""}{" "}
                        </span>{" "}
                        মোবাইল মেনুতে যান অথবা বিকাশ অ্যাপে যান।{" "}
                        <span className="font-semibold">Send Money</span> অপশনে
                        ক্লিক করুন। প্রাপক নম্বর হিসেবে এই নম্বরটি লিখুনঃ
                        <span
                          className="text-brand mx-1 cursor-pointer"
                          onClick={() => {
                            clickToCopy("01799361321");
                            notify("Number Copied to your clipboard");
                          }}
                          title="Click to Copy"
                        >
                          01799361321
                        </span>{" "}
                        অথবা
                        <span
                          className="text-brand mx-1 cursor-pointer"
                          onClick={() => {
                            clickToCopy("01833534123");
                            notify("Number Copied to your clipboard");
                          }}
                          title="Click to Copy"
                        >
                          01833534123
                        </span>{" "}
                        নাম্বার এবং টাকার পরিমানে {selectedItem?.price} টাকা
                        দিন। এরপর পেমেন্ট নিশ্চিত করতে আপনার বিকাশ পিন লিখুন।
                        সবকিছু ঠিক থাকলে, আপনি বিকাশ থেকে একটি নিশ্চিতকরণ বার্তা
                        পাবেন। এখন নিচের বক্সে আপনার{" "}
                        <span className="font-semibold">Transaction ID</span>{" "}
                        এবং
                        <span className="font-semibold">Mobile No</span> দিন এবং{" "}
                        <span className="font-semibold">SUBMIT</span> বাটনে
                        ক্লিক করুন।
                      </p>
                    </div>
                  </>
                )}
                <div className="my-5">
                  <Textinput
                    title={selectedPaymentMethod + " Account Number"}
                    name={"order_account"}
                    type={"text"}
                    placeholder={
                      "Enter Your " + selectedPaymentMethod + " Account Number"
                    }
                    onChange={(e) => setAccountNumber(e.target.value)}
                    className={`border rounded w-full py-2 px-4 border-orange-300`}
                  />
                  <Textinput
                    title={selectedPaymentMethod + " Transaction ID"}
                    name={"order_trxid"}
                    type={"text"}
                    placeholder={
                      "Enter Your " + selectedPaymentMethod + " Transaction ID"
                    }
                    className={`border rounded w-full py-2 px-4 border-orange-300`}
                    onChange={(e) => setTrxId(e.target.value)}
                  />
                </div>
              </div>
              {selectedPaymentMethod !== "other" && (
                <div>
                  <button
                    type="submit"
                    className={`${
                      selectedItem === null
                        ? "bg-none border rounded-lg cursor-no-drop "
                        : "site-btn"
                    } p-3 mr-2 my-2 w-1/2  click-effect`}
                  >
                    Submit
                    <i
                      className={`fa fa-shopping-cart ml-2`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
